/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Price_ListInputs */

const en_reference_dataset_price_list = /** @type {(inputs: Reference_Dataset_Price_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price lists`)
};

/**
* | output |
* | --- |
* | "Price lists" |
*
* @param {Reference_Dataset_Price_ListInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_price_list = /** @type {((inputs?: Reference_Dataset_Price_ListInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Price_ListInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_price_list(inputs)
});